"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var antd_1 = require("antd");
var CardRowTextAreaEditor_1 = require("../../../../../../shared/components/editors/CardRowTextAreaEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var TextArea = antd_1.Input.TextArea;
var AppCapchaTemplateEditor = /** @class */ (function (_super) {
    __extends(AppCapchaTemplateEditor, _super);
    function AppCapchaTemplateEditor(props) {
        return _super.call(this, props) || this;
    }
    AppCapchaTemplateEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    dir_name_select_to: _item.dir_name_select_to,
                    dir_list_rubbish: _item.dir_list_rubbish,
                    row_count: _item.row_count,
                    col_count: _item.col_count,
                    sel_count_min: _item.sel_count_min,
                    sel_count_max: _item.sel_count_max,
                    quest_text: _item.quest_text,
                    is_locked: _item.is_locked,
                    description: _item.description
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование шаблона капчи"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                dir_name_select_to: "",
                dir_list_rubbish: "",
                row_count: 0,
                col_count: 0,
                sel_count_max: 0,
                sel_count_min: 0,
                quest_text: "",
                is_locked: false,
                description: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание шаблона капчи"]);
            });
        }
        this.doReSetRules();
    };
    AppCapchaTemplateEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            dir_name_select_to_rules: { isError: false },
            dir_list_rubbish_rules: { isError: false },
            row_count_rules: { isError: false },
            col_count_rules: { isError: false },
            sel_count_max_rules: { isError: false },
            sel_count_min_rules: { isError: false },
            quest_text_rules: { isError: false }
        });
    };
    AppCapchaTemplateEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        // if ((this.state.firewall_id <= 0) || (this.state.firewall_title.length === 0)) {
        //     this.setState({ firewall_rules: { isError: true, errorMessage: "Поле [firewall] не выбрано!" } })
        //     return false;
        // }
        if ((!this.state.row_count) || (this.state.row_count <= 0)) {
            this.setState({ row_count_rules: { isError: true, errorMessage: "Поле [кол-во строк] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        if ((!this.state.col_count) || (this.state.col_count <= 0)) {
            this.setState({ col_count_rules: { isError: true, errorMessage: "Поле [кол-во столбцов] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        if ((!this.state.sel_count_min) || (this.state.sel_count_min <= 0)) {
            this.setState({ sel_count_min_rules: { isError: true, errorMessage: "Поле [макс кол-во ответов] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        if ((!this.state.sel_count_max) || (this.state.sel_count_max <= 0)) {
            this.setState({ sel_count_max_rules: { isError: true, errorMessage: "Поле [мин кол-во ответов] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название капчи] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        if ((!this.state.dir_name_select_to) || (this.state.dir_name_select_to.length === 0)) {
            this.setState({ dir_name_select_to_rules: { isError: true, errorMessage: "Поле [каталог капчи] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        if ((!this.state.dir_list_rubbish) || (this.state.dir_list_rubbish.length === 0)) {
            this.setState({ dir_list_rubbish_rules: { isError: true, errorMessage: "Поле [каталоги случайных данных] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        if ((!this.state.quest_text) || (this.state.quest_text.length === 0)) {
            this.setState({ quest_text_rules: { isError: true, errorMessage: "Поле [задача капчи] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        //if (this.state.domain_template.indexOf("{0}") < 0) {
        //    this.setState({ domain_template_rules: { isError: true, errorMessage: "Поле [шаблон домена] заполнено некорректно - необходим {0}!" } })
        //    return false;
        //}
        return true;
    };
    AppCapchaTemplateEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                dir_name_select_to: this.state.dir_name_select_to,
                dir_list_rubbish: this.state.dir_list_rubbish,
                row_count: this.state.row_count,
                col_count: this.state.col_count,
                sel_count_min: this.state.sel_count_min,
                sel_count_max: this.state.sel_count_max,
                quest_text: this.state.quest_text,
                is_locked: this.state.is_locked,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон капчи изменен!");
            });
        }
    };
    AppCapchaTemplateEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                title: this.state.title,
                dir_name_select_to: this.state.dir_name_select_to,
                dir_list_rubbish: this.state.dir_list_rubbish,
                row_count: this.state.row_count,
                col_count: this.state.col_count,
                sel_count_min: this.state.sel_count_min,
                sel_count_max: this.state.sel_count_max,
                quest_text: this.state.quest_text,
                is_locked: this.state.is_locked,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон капчи добавлен!");
            });
        }
    };
    AppCapchaTemplateEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AppCapchaTemplateEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить шаблон капчи";
        }
        else {
            return "Изменить шаблон капчи";
        }
    };
    AppCapchaTemplateEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ dir_name_select_to: brandIdentity + "/" + dirName + "/" }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    AppCapchaTemplateEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 900 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название шаблона капчи" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Каталог изображений:",
                    placeholder: "Выберите каталог изображений",
                    buttonHint: "Выберите каталог изображений"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        dir_name_select_to: newVal,
                        dir_name_select_to_rules: { isError: false }
                    });
                }, value: this.state.dir_name_select_to, buttonIcon: "search", required: true, rules: this.state.dir_name_select_to_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Каталоги мусора:", placeholder: "Укажите список каталогов мусора" }, rowsCount: 5, onValueChanged: function (newVal) {
                    _this.setState({ dir_list_rubbish: newVal });
                }, value: this.state.dir_list_rubbish, required: true }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во строк", placeholder: "Введите количество строк" }, values: { max: 999, min: 1, value: this.state.row_count }, onValueChanged: function (newVal) {
                    _this.setState({
                        row_count: newVal,
                        row_count_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.row_count_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во столбцов", placeholder: "Введите количество столбцов" }, values: { max: 999, min: 1, value: this.state.col_count }, onValueChanged: function (newVal) {
                    _this.setState({
                        col_count: newVal,
                        col_count_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.col_count_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин кол-во ответов", placeholder: "Введите минимальное количество ответов" }, values: { max: 999, min: 1, value: this.state.sel_count_min }, onValueChanged: function (newVal) {
                    _this.setState({
                        sel_count_min: newVal,
                        sel_count_min_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.sel_count_min_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс кол-во ответов", placeholder: "Введите максимальное количество ответов" }, values: { max: 999, min: 1, value: this.state.sel_count_max }, onValueChanged: function (newVal) {
                    _this.setState({
                        sel_count_max: newVal,
                        sel_count_max_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.sel_count_max_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Вопрос капчи:", placeholder: "Укажите вопрос капчи" }, rowsCount: 5, onValueChanged: function (newVal) {
                    _this.setState({ quest_text: newVal });
                }, value: this.state.quest_text, required: true }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Шаблон капчи заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return AppCapchaTemplateEditor;
}(React.Component));
exports.default = AppCapchaTemplateEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_capcha/ui/component/AppCapchaTemplateEditor.tsx
// module id = 2576
// module chunks = 0